import { render, staticRenderFns } from "./goodsClassifyGroup.vue?vue&type=template&id=552ed399&scoped=true&"
import script from "./goodsClassifyGroup.vue?vue&type=script&lang=js&"
export * from "./goodsClassifyGroup.vue?vue&type=script&lang=js&"
import style0 from "./goodsClassifyGroup.vue?vue&type=style&index=0&id=552ed399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ed399",
  null
  
)

export default component.exports